<template>
  <div class="xidian">
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/banner.jpg"
    ></van-image>
    <form1 bgc="#f2eeed"></form1>
    <div style="width: 100%; height: 10px; background: #f2eeed"></div>
    <div class="block1">
     
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/title1.jpg"
      ></van-image>
         <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p1.jpg"
      ></van-image>
         </a>
    </div>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p2.jpg"
      style="margin-bottom: -6px"
    ></van-image>
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p3.jpg"
    ></van-image>
       </a>
    <form1 bgc="#ffffff"></form1>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p4.jpg"
      style="margin-bottom: -6px"
    ></van-image>
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p5.jpg"
      style="margin-bottom: -6px"
    ></van-image>
       </a>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/title2.jpg"
      style="margin-bottom: -6px"
    ></van-image>
    <van-image
      src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p6.jpg"
      style="margin-bottom: -6px"
    ></van-image>
    <div
      style="
        width: 100%;
        text-align: center;
        background: #f2eeed;
        padding: 16px;
      "
    >
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-button
        color="linear-gradient(to right,#ee0a24,#ff6034)"
        size="small"
        style="
          border-radius: 4px;
          width: 60%;
          font-size: 18px;
          font-weight: 600;
        "
      >
        获取学费信息
      </van-button>
       </a>
    </div>
    <div
      style="
        width: 100%;
        text-align: center;
        background: #f2eeed;
        padding: 16px 0;
      "
    >
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p8.jpg"
        style="margin-top: 16px"
      ></van-image>
      
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p9.jpg"
        style="margin-top: -6px"
      ></van-image>
       </a>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p10.jpg"
        style="margin-top: -6px"
      ></van-image>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p11.jpg"
        style="margin-top: -6px"
      ></van-image>
       <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p12.jpg"
        style="margin-top: -6px"
      ></van-image>
       <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
         <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p13.jpg"
        style="margin-top: -6px"
      ></van-image>
       </a>
       <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p14.jpg"
        style="margin-top: -6px"
      ></van-image>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/p15.png"
        style="margin-top: -6px"
      ></van-image>
    </div>
    <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/xidian/foot.jpg"
        style="margin-top:-22px"  
      ></van-image>
        <div class="foot-info">
          <!-- <div class="foot-info-one">版权所有:北京朗杰科技有限公司</div> -->
         <div class="foot-info-one"><a href="http://www.beian.miit.gov.cn">蜀ICP备14019303号-1</a></div>
      </div>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import("@/components/common/landing-banner"),
    form1: () => import("@/components/form/form1"),
    back: () => import("@/components/head/back"),
    foot: () => import("@/components/foot/foot"),
    find: () => import("@/components/common/find"),
    find3: () => import("@/components/common/find3"),
    indexTitle: () => import("@/components/common/indexTitle"),
    footerForm: () => import("@/components/form/footerForm"),
  },
};
</script>

<style lang="less" scoped>
.block1 {
  background: #ffffff;
}
.foot-info{
  width: 100%;
  height: 20px;
  font-size: 12px;
}
.foot-info-one{
  width: 100%;
  height: 15px;
  text-align: center;
}
</style>